import React from "react";
import { Field } from "formik";
import { isFunction } from "lodash";

const validateField = value => {
  let error;
  if (!value || value <= 0) {
    error = "This field is required";
  }
  return error;
};

class Number extends React.PureComponent {
  render() {
    const { name, validate, title, errors, submitCount, touched } = this.props;

    let className =
      (errors && (touched || !!submitCount) ? "error is-invalid" : "") +
      " text-input form-control";

    return (
      <React.Fragment>
        {title &&  <label>{title}</label>}
        <div className="input-group mb-3">
          <Field
            {...this.props}
            name={name}
            className={className}
            validate={
              validate && (isFunction(validate) ? validate : validateField)
            }
            type="Number"
          />
          {errors && touched && (
            <div className="invalid-feedback">{errors}</div>
          )}
        </div>
      </React.Fragment>
    );
  }
}

export default Number;
